export default __webpack_public_path__ + "780af746322f684bd092a8312e9ee309.png";